.select {
  & svg {
    margin-left: 4px;
  }

  & input {
    text-align: center;
    font-weight: bold;
    width: 100px;
    border-radius: var(--mantine-radius-md);
    font-weight: bold;
  }
}

.transparent input {
  background-color: rgba(0, 0, 0, 0.15) !important;
  color: white;
  border: none;
}
